/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.app.permissions.hublets.rpc.AppPermissionsHubletsPublicRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type AppPermissionGetError = {
  errorType: ErrorType;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
};

export type AppPermissionTranslationBatchPublicRequest = {
  appPermissionNames: Default<string[]>;
  locale: string;
};

export type AppPermissionTranslationBatchPublicResponse = {
  translations: Default<AppPermissionTranslationItemPublic[]>;
};

export type AppPermissionTranslationItemPublic = {
  appPermissionName: string;
  label?: string;
  description?: string;
};

export type ErrorType =
  | 'NOT_FOUND'
  | 'INTERNAL_ERROR'
  | 'ILLEGAL_ARGUMENT'
  | unhandledEnumCase;

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type GetAppPermissionTranslationsRequestType =
  Requestify<AppPermissionTranslationBatchPublicRequest>;
export type GetAppPermissionTranslationsResponseType =
  AppPermissionTranslationBatchPublicResponse;
export type GetAppPermissionTranslationsErrorType = AppPermissionGetError &
  HubspotMetadata;
export const getAppPermissionTranslationsRpc: ChirpAvroRpcDetails<
  GetAppPermissionTranslationsRequestType,
  GetAppPermissionTranslationsResponseType,
  GetAppPermissionTranslationsErrorType,
  false
> = {
  serviceName:
    'com.hubspot.app.permissions.hublets.rpc.AppPermissionsHubletsPublicRpc',
  rpcName: 'getAppPermissionTranslations',
  auth: 'external',
  fingerprint: '7do5wyaI2vhjOM8JpLEURAxAsniWr2JX',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
